module.exports = __webpack_public_path__ + "static/comofunciona-cc13d6ad22ccf30a5753f87f33d2780f.svg";